import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPagination = params => ({
  type: actionTypes.SET_VEHICLE_PARTS_PAGINATION,
  payload: params
})
